function tracking() {
    // Get any events from the data attributes
    function getEvents(node) {
        let events = {
            'gtm': node.dataset.googleEventCategory ?? null,
            'fb': node.dataset.facebookEventTrack ?? null,
        };

        return Object.keys(events)
            .filter((k) => events[k] != null)
            .reduce((a, k) => ({ ...a, [k]: events[k] }), {});
    }

    // Process any of the events passing the data value
    function handleEvents(events) {
        for (const key in events) {
            switch (key) {
                case 'gtm':
                    pushGoogleEvent(events[key]);
                    break;
                case 'fb':
                    pushFacebookEvent(events[key]);
                    break;
            }
        }
    }

    // Sends event to Google
    function pushGoogleEvent(category) {
        if (!window.hasOwnProperty("dataLayer")) {
            return;
        }

        window.dataLayer.push({
            event: "click",
            method: "",
            transport_type: "beacon",
            event_category: category,
        });
    }

    // Sends event to Facebook
    function pushFacebookEvent(eventName) {
        if (!window.hasOwnProperty("fbq")) {
            return;
        }

        window.fbq("track", eventName);
    }

    // Adds an event listener to all tracked buttons
    document.querySelectorAll("[data-event-trigger]")?.forEach(node => {
        const EVENT_LISTENER_TYPE = node.dataset.eventTriggerType || "click";

        node.addEventListener(EVENT_LISTENER_TYPE, (e) => {
            e.stopPropagation();
            let events = getEvents(node);
            handleEvents(events);
        });
    });
}

export default tracking();
